import React from 'react'
import PropTypes from 'prop-types'

import { Danger } from 'iconsax-react'

import styles from './styles.module.css'
import useColors from 'utils/Colors'

const FormField = ({ title, required, control, message }) => {
  const getMessageIconColor = (type) => {
    switch (type) {
      case 'error':
        return Colors.Danger[5]

      case 'warning':
        return Colors.Warning[50]

      case 'ok':
        return Colors.Success[70]

      default:
        return ''
    }
  }

  const Colors = useColors()

  return (
    <div className={styles.container}>
      {title && (
        <label className={required ? styles.required_label : undefined}>
          {title}
        </label>
      )}
      {control}
      {message && (
        <div className={styles.message_box}>
          {message.rightComponent ? (
            <div className={styles.right_comp}>
              <Danger
                color={getMessageIconColor(message?.type)}
                style={{ marginLeft: 4 }}
                variant="Bold"
                size={14}
              />
              {message.rightComponent}
            </div>
          ) : (
            <span></span>
          )}
          {message.leftComponent ? message.leftComponent : <span></span>}
        </div>
      )}
    </div>
  )
}

FormField.propTypes = {
  title: PropTypes.string,
  required: PropTypes.bool,
  control: PropTypes.object,
  message: PropTypes.object,
}

FormField.defaultProps = {
  title: '',
  required: false,
  control: <></>,
}

export default FormField
